/* eslint-disable */
// @flow

import React, { Component } from 'react';
import type { ComponentType } from 'react';

// $FlowFixMe fixing import because flow can not import this module
import CircleLoader from 'ggApp/shared/components/CircleLoader';


type optionsPayload = {
    componentName: ?string,
    timeout: ?number,
    loader: ?ComponentType<any>,
    loaderProps: ?Object<any>,
};

type stateType = {
    component: ?ComponentType<any>,
};

const defaultOptions: optionsPayload = {
    componentName: 'default',
    timeout: 500,
    loader: CircleLoader,
    loaderProps: {
        dark: true,
        main: true,
        active: true,
    },
};

export default function asyncComponent(
    importComponent: () => Promise<any>,
    options: optionsPayload,
): ComponentType<any> {
    class AsyncComponent extends Component<any, stateType> {
        options: optionsPayload;

        constructor(props) {
            super(props);

            this.state = {
                component: null,
            };

            this.options = { ...defaultOptions, ...options };
        }

        componentDidMount() {
            const { componentName } = this.options;

            Promise.all([importComponent(), this.timeout()]).then(([module]) => {
                this.setState({
                    component: module[componentName],
                });
            }).catch((error) => {
                if (__DEVELOPMENT__) {
                    console.error('ERROR LOADING ASYNC COMPONENT: ', error);
                }
            });
        }

        timeout(): Promise<void> {
            const { timeout } = this.options;
            return new Promise((resolve) => setTimeout(() => resolve(), timeout || 0));
        }

        render() {
            const { loader: Loader, loaderProps } = this.options;
            const { component: LoadedComponent } = this.state;

            if (LoadedComponent) {
                return <LoadedComponent {...this.props} />;
            }

            if (Loader) {
                return <Loader {...loaderProps} />;
            }

            return null;
        }
    }

    return AsyncComponent;
}
